import user from './user'
import order from './order'
import credit from './credit'
import feed from './feed'
import reservation from './reservation'
import userCoupon from './userCoupon'
import installation from './installation'
import notification from './notification'
import pospal from './pospal'

export default {
    ...user,
    ...order,
    ...credit,
    ...feed,
    ...reservation,
    ...userCoupon,
    ...installation,
    ...notification,
    ...pospal
}